import _ from 'lodash'

export default function isNotNullOrUndefined(n) {
  return !_.isNull(n) && !_.isUndefined(n)
}
